import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { AMBASSADOR_ENABLED, getVisitorId, storeRef } from "../lib/ambassadorRef";

export default function Join() {
  const [params] = useSearchParams();
  const nav = useNavigate();

  useEffect(() => {
    const code = (params.get("ref") || "").trim().toUpperCase();
    const rest = new URLSearchParams(params);
    rest.delete("ref");
    const qs = rest.toString();
    const go = () => nav(`/signup${qs ? `?${qs}` : ""}`, { replace: true });
    if (!AMBASSADOR_ENABLED || !/^[A-Z0-9]{2,20}$/.test(code)) { go(); return; }
    api.post("/ambassadors/click", { code, visitor_id: getVisitorId() })
      .then((r) => { if (r.data && r.data.valid) storeRef(r.data.code); })
      .catch(() => {})
      .finally(go);
  }, [params, nav]);

  return (
    <div data-testid="join-redirecting" style={{ padding: 48, textAlign: "center", color: "var(--navy)" }}>
      Taking you to Métier…
    </div>
  );
}
